import React, { useState, useEffect } from 'react';
import { FaRegEye,FaImage, FaRegFilePdf, FaLink, FaRegFileAlt, FaVideo, FaFileWord, FaFileExcel } from "react-icons/fa";

import { ProactiveData, BackProactiveData, ProactiveItem, ProactiveListViewProps } from './types';

// Declaración global para TypeScript
declare global {
    interface Window {
        ProactiveListData: BackProactiveData[];
    }
}

export const ProactiveList: React.FC<ProactiveListViewProps> = ({ onItemClick }) => {
    const [proactiveData, setProactiveData] = useState<ProactiveItem[]>([]);
    const [siteUrl, setSiteUrl] = useState<string>('');

    useEffect(() => {
    // Obtener datos del window object
        if (window.ProactiveListData && window.ProactiveListData.length > 0) {
            const data:ProactiveData = window.ProactiveListData[0].data;
            setProactiveData(data.interest);
            setSiteUrl(data.site_url);
        }
    }, []);

    // Función para obtener el icono basado en la extensión del archivo
    const getFileIcon = (filePath: string): JSX.Element => {
        if (!filePath || typeof filePath !== 'string') {
            // Icono por defecto para valores nulos/vacíos
            return <span className="piece-icon" style={{ color: '#6c757d' }}><FaLink/></span>;
        }
        const extension = filePath.split('.').pop()?.toLowerCase();
        switch (extension) {
            case 'pdf':
                return <span className="piece-icon" style={{ color: '#dc3545' }}><FaRegFilePdf/></span>;
            case 'jpg':
                return <span className="piece-icon" style={{ color: '#28a745' }}><FaImage/></span>;
            case 'jpeg':
                return <span className="piece-icon" style={{ color: '#28a745' }}><FaImage/></span>;
            case 'png':
                return <span className="piece-icon" style={{ color: '#28a745' }}><FaImage/></span>;
            case 'gif':
                return <span className="piece-icon" style={{ color: '#28a745' }}><FaImage/></span>;
            case 'mp4':
                return <span className="piece-icon" style={{ color: '#6f42c1' }}><FaVideo/></span>;
            case 'avi':
                return <span className="piece-icon" style={{ color: '#6f42c1' }}><FaVideo/></span>;
            case 'mov':
                return <span className="piece-icon" style={{ color: '#6f42c1' }}><FaVideo/></span>;
            case 'doc':
                return <span className="piece-icon" style={{ color: '#007bff' }}><FaRegFileAlt/></span>;
            case 'docx':
                return <span className="piece-icon" style={{ color: '#007bff' }}><FaFileWord/></span>;
            case 'xls':
                return <span className="piece-icon" style={{ color: '#fd7e14' }}><FaFileExcel/></span>;
            case 'xlsx':
                return <span className="piece-icon" style={{ color: '#fd7e14' }}><FaFileExcel/></span>;
            default:
                return <span className="piece-icon" style={{ color: '#6c757d' }}><FaLink/></span>;
        }
    };

  // Función para obtener el tipo de archivo
    const getFileType = (filePath: string): string => {
        if (!filePath || typeof filePath !== 'string') {
            // Icono por defecto para valores nulos/vacíos
            return 'Archivo';
        }
        const extension = filePath.split('.').pop()?.toLowerCase();
        switch (extension) {
            case 'pdf':
                return 'PDF';
            case 'jpg':
                return 'Imagen';
            case 'jpeg':
                return 'Imagen';
            case 'png':
                return 'Imagen';
            case 'gif':
                return 'Imagen';
            case 'mp4':
                return 'Video';
            case 'avi':
                return 'Video';
            case 'mov':
                return 'Video';
            case 'doc':
                return 'Documento';
            case 'docx':
                return 'Documento';
            case 'xls':
                return 'Hoja de cálculo';
            case 'xlsx':
                return 'Hoja de cálculo';
            default:
                return 'Archivo';
        }
    };

  // Función para manejar el clic en un item
    const handleItemClick = (item: ProactiveItem) => {
        window.location.href = `${siteUrl}/index.php/proactive-view?id=${item.proactive_id}`;
    };

    return (
        <div className="nav-wrapper">
            <h1 className="nav-title">Información Proactiva</h1>
            
            {proactiveData.length === 0 ? (
            <div className="loading-state">
                <p>No hay información proactiva</p>
            </div>
            ) : (
            <div>
            {/* Estadísticas */}
            <div style={{ 
                textAlign: 'center', 
                marginBottom: '2rem',
                color: 'var(--text-light)',
                fontSize: '1.1rem'
            }}>
                <strong>{proactiveData.length}</strong> publicaciones disponibles
            </div>

            {/* Lista de elementos usando el sistema de accordions */}
            <div className="accordion-list">
            {proactiveData.map((item) => (
                <div key={item.proactive_id} className="accordion-article">
                <button
                    className="accordion-header"
                    onClick={() => handleItemClick(item)}
                    style={{ width: '100%', textAlign: 'left' }}
                >
                    {getFileIcon(item.file_path)}
                    
                    <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ 
                        fontSize: '1.2rem', 
                        fontWeight: '700',
                        marginBottom: '0.3rem',
                        color: 'var(--primary-dark)'
                    }}>
                        {item.title}
                    </div>
                    <div style={{ 
                        fontSize: '0.95rem',
                        opacity: '0.8',
                        lineHeight: '1.4',
                        color: 'var(--text-main)'
                    }}>
                        {item.description_snippet.length > 120
                        ? `${item.description_snippet.substring(0, 120)}...`
                        : item.description_snippet
                        }
                    </div>
                    <div style={{
                        display: 'flex',
                        gap: '1rem',
                        marginTop: '0.5rem',
                        fontSize: '0.85rem',
                        color: 'var(--text-light)'
                    }}>
                        <span><strong>Tipo:</strong> {getFileType(item.file_path)}</span>
                    </div>
                    </div>
                    
                    <div className="accordion-chevron" style={{ marginLeft: '1rem' }}>
                    <FaRegEye/>
                    </div>
                </button>
                </div>
            ))}
            </div>
        </div>
        )}
    </div>
    );
};

export default ProactiveList;